// extracted by mini-css-extract-plugin
export var container = "_5f-0";
export var error = "_5f-9";
export var label = "_5f-5";
export var light = "_5f-6";
export var md = "_5f-3";
export var sm = "_5f-2";
export var thin = "_5f-8";
export var thinBold = "_5f-7";
export var vertical = "_5f-4";
export var xs = "_5f-1";